import * as Blocks from "@components/blocks/export"
import { apiPlugin, ISbCache, ISbResult, storyblokInit } from "@storyblok/react/rsc"

const MAX_ENTRIES = 1000

// Storyblok bills every request, edge-cached or not. Published responses are kept per container
// until a publish changes the cv (which changes the cache key, and makes the SDK flush this store).
function makeResponseCache(): NonNullable<ISbCache["custom"]> {
  const entries = new Map<string, ISbResult>()

  return {
    get(key: string) {
      const hit = entries.get(key)
      if (hit) {
        // Re-insert so the Map's insertion order doubles as least-recently-used order.
        entries.delete(key)
        entries.set(key, hit)
      }
      return Promise.resolve(hit)
    },
    // Unused by the SDK.
    getAll() {
      return Promise.resolve(undefined)
    },
    set(key: string, value: ISbResult) {
      entries.delete(key)
      entries.set(key, value)
      while (entries.size > MAX_ENTRIES) entries.delete(Array.from(entries.keys())[0])
      return Promise.resolve(undefined)
    },
    flush() {
      entries.clear()
      return Promise.resolve(undefined)
    }
  }
}

export const getStoryblokApi = storyblokInit({
  accessToken: process.env.STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  apiOptions: {
    cache: { type: "custom", custom: makeResponseCache() }
  },
  components: Object.fromEntries(Object.entries(Blocks))
})
